"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var EnquiryFormSubmitErrorCodes;
(function (EnquiryFormSubmitErrorCodes) {
    EnquiryFormSubmitErrorCodes[EnquiryFormSubmitErrorCodes["VALIDATION_ERROR"] = 400100] = "VALIDATION_ERROR";
})(EnquiryFormSubmitErrorCodes || (EnquiryFormSubmitErrorCodes = {}));
exports.default = EnquiryFormSubmitErrorCodes;
